@if (couponsCarouselList?.length) {
    <div
        class="surface-bets-container"
        [ngClass]="{ 'surface-bets-container-coral': isCoral }"
        data-crlat="surfaceBetsCarousel"
        [elemEventType]="'touchmove'"
        [scrollonce]="'surfaceBet'">
        <div class="coupon-carousel-header" [ngClass]="{ 'coral-slide': isCoral }">
            <div class="featured-title">
                <div [textContent]="title" class="coupon-crl-lads" data-crlat="couponCarousel.title"></div>
            </div>
        </div>
        <div
            class="ng-carousel surface-bets-carousel coupon-carousel"
            [ngClass]="{ 'surface-bets-carousel-lads': !isCoral }"
            [ngCarouselSA]
            ngCarouselExtended
            [ngCarouselWatch]="getCarouselLength()"
            [ngCarouselName]="carouselName"
            [ngCarouselFluid]="true"
            [ngCarouselLoop]="false"
            [ngCarouselMoveThresholdPercentage]="5">
            @if (showCarouselButtons && isDesktop && carousel) {
                <div class="scroll-buttons">
                    <button class="hc-arrow prev-hc-card" (click)="prevSlide()" [ngClass]="{ 'hc-arrow-hide': !showPrev }">
                        <svg>
                            <use xlink:href="#prev-arrow"></use>
                        </svg>
                        <span [i18n]="'sb.previousCard'"></span>
                    </button>
                    <button class="hc-arrow next-hc-card" (click)="nextSlide()" [ngClass]="{ 'hc-arrow-hide': !showNext }">
                        <span [i18n]="'sb.nextCard'"></span>
                        <svg>
                            <use xlink:href="#next-arrow"></use>
                        </svg>
                    </button>
                </div>
            }
            @if (couponsCarouselList?.length) {
                <slidecontainer class="carousel-slides coupon-slide">
                    @for (
                        coupons of couponsCarouselList;
                        track '$' + $index + '$' + coupons.marketSelector + '$' + coupons.dateBanner;
                        let i = $index
                    ) {
                        <slide class="slide" [ngClass]="{ 'coral-slide': isCoral }">
                            <div class="coupon-container" [ngStyle]="{ background: coupons.gradientCss }" (click)="couponUrl(coupons)">
                                <div class="coupon-header" [ngClass]="{ 'coupon-header-ladsdesk': !isCoral && isDesktop }">
                                    <span
                                        class="coupon-header-content"
                                        [ngClass]="{ 'coupon-content-ladsdesk': !isCoral && isDesktop }"
                                        [textContent]="coupons.dateBanner"></span>
                                </div>
                                <div class="coupon-content" [textContent]="coupons.title"></div>
                            </div>
                        </slide>
                    }
                </slidecontainer>
            }
        </div>
    </div>
}
